const CONTROLLER = "/job-draft";
const PATHS = {
  CREATE_DRAFT: "",
  GET_ALL_MY_JOB_DRAFTS: "",
  GET_JOB_DRAFT_BY_ID: "/:draft_id",
  MODIFY_JOB_DRAFT: "/:draft_id",
  DELETE_JOB_DRAFT: "/:draft_id",
  PUBLISH_DRAFT: "/:draft_id/publish",

  SEND_APPLICATION: "/:draft_id/application",
  DELETE_APPLICATION: "/:draft_id/application",
  SHARE_JOB: "/:draft_id/share",
  SAVE_JOB: "/:draft_id/save",
  UNSAVE_JOB: "/:draft_id/save",
  CHECK_IF_JOB_IS_SAVED_BY_USER: "/:draft_id/save",
};

export const JobDraftApiRoutesNames = Object.fromEntries(
  (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k])
) as {
  [K in keyof typeof PATHS]: K;
};

export const JobDraftApiRoutes = {
  CONTROLLER,
  PATHS,
  CREATE_DRAFT: `${CONTROLLER}${PATHS.CREATE_DRAFT}`,
  GET_ALL_MY_JOB_DRAFTS: `${CONTROLLER}${PATHS.GET_ALL_MY_JOB_DRAFTS}`,
  GET_JOB_DRAFT_BY_ID: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.GET_JOB_DRAFT_BY_ID.replace(
      ":draft_id",
      String(draft_id)
    )}`,
  MODIFY_JOB_DRAFT: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.MODIFY_JOB_DRAFT.replace(
      ":draft_id",
      String(draft_id)
    )}`,
  DELETE_JOB_DRAFT: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.DELETE_JOB_DRAFT.replace(
      ":draft_id",
      String(draft_id)
    )}`,
  PUBLISH_DRAFT: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.PUBLISH_DRAFT.replace(
      ":draft_id",
      String(draft_id)
    )}`,

  SEND_APPLICATION: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.SEND_APPLICATION.replace(
      ":draft_id",
      String(draft_id)
    )}`,
  DELETE_APPLICATION: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.DELETE_APPLICATION.replace(
      ":draft_id",
      String(draft_id)
    )}`,
  SHARE_JOB: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.SHARE_JOB.replace(":draft_id", String(draft_id))}`,
  SAVE_JOB: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.SAVE_JOB.replace(":draft_id", String(draft_id))}`,
  UNSAVE_JOB: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.UNSAVE_JOB.replace(":draft_id", String(draft_id))}`,
  CHECK_IF_JOB_IS_SAVED_BY_USER: (draft_id: string | undefined) =>
    `${CONTROLLER}${PATHS.CHECK_IF_JOB_IS_SAVED_BY_USER.replace(
      ":draft_id",
      String(draft_id)
    )}`,
};
